"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tasas = void 0;
exports.tasas = {
    1: { nombre: "TE", valor: 0 },
    2: { nombre: "TM", valor: 10 },
    3: { nombre: "TB", valor: 22 },
    4: { nombre: "Otra", valor: 0 },
    5: { nombre: "Gratis", valor: 0 },
    6: { nombre: "NF", valor: 0 },
    7: { nombre: "NF", valor: 0 },
    8: { nombre: "Remi", valor: 0 },
    9: { nombre: "Resg", valor: 0 },
    10: { nombre: "TEXPO", valor: 0 },
    11: { nombre: "IVA Percibido", valor: 0 },
    12: { nombre: "IVA suspenso", valor: 0 },
    13: { nombre: "eBoleta", valor: 0 },
    14: { nombre: "eBoleta", valor: 0 },
    15: { nombre: "eBoleta", valor: 0 },
    16: { nombre: "TE", valor: 0 },
    17: { nombre: "eBoleta", valor: 0 }
};
